import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { Notification } from "@cxagroup/casper";
import { Checkbox } from "cxa-components";
import messages from "components/messagesDescription";
import { load, save, removeExpiredItemsFromCart } from "actions/checkoutActions";
import { isExist, benefitsErrorHandler } from "cxa-utils";
import BenefitCheckoutItems from "./BenefitCheckoutItems";
import CheckoutSummary from "./CheckoutSummary";
import EnableShopButtons from "./enableShopButtons";

const OVERPURCHASE_AMOUNT_TOKEN = "[ExcessAmount]";

class CheckoutContainer extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    push: PropTypes.func,
    loadCheckoutItems: PropTypes.func,
    saveCheckout: PropTypes.func,
    data: PropTypes.object,
    fetching: PropTypes.bool,
    saving: PropTypes.bool,
    saved: PropTypes.bool,
    checkoutResult: PropTypes.bool,
    networkError: PropTypes.object,
    isEnrolmentEnabled: PropTypes.bool,
    removeExpiredItems: PropTypes.func,
    common: PropTypes.object,
    isNarrowScreen: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      agreement: false,
      overPurchaseAgreement: false,
    };

    this.doRedirect(props);
  }

  // TODO: componentWillReceiveProps
  componentDidUpdate() {
    this.doRedirect(this.props);
  }

  componentDidMount() {
    this.reloadData();
  }

  doRedirect(props) {
    if (props.saved === true && props.checkoutResult === true && props.isEnrolmentEnabled) {
      props.push("/benefits/statement");
    }
  }

  reloadData = () => {
    this.props.loadCheckoutItems(true);
  };

  showBenefits = () => {
    this.props.push("/shop/enrolment");
    window.location.reload(false);
  };

  showWellness = () => {
    this.props.push("/shop/health-wellness");
  };

  createCheckoutHandler = agreementRequired => () => {
    const { isEnrolmentEnabled, saveCheckout } = this.props;
    saveCheckout(!isEnrolmentEnabled || (agreementRequired ? this.state.agreement : true));
  };

  changeAgreement = e => {
    const agreement = e.target.checked;
    this.setState(state => ({ ...state, agreement }));
  };

  changeOverpurchaseAgreement = e => {
    const overPurchaseAgreement = e.target.checked;
    this.setState(state => ({ ...state, overPurchaseAgreement }));
  };


  // TODO: diet render method code
  render() {
    const {
      data,
      saving,
      isEnrolmentEnabled,
      intl,
      removeExpiredItems,
      common,
      isNarrowScreen,
      networkError,
    } = this.props;
    let errorText;

    if (!data || !data.data || !data.panels) {
      return null;
    }

    if (isExist(networkError)) {
      const { message, extra } = networkError;
      const applyErrorHandler = benefitsErrorHandler(intl);

      errorText = applyErrorHandler({
        extraValue: extra,
        messageKey: message,
        message,
      });
    }

    // this gets passed in sub-components in BenefitCheckoutItem, WellnessCheckOutItem and CheckOutSummary
    const enrolmentCurrency = data.data.clientSettings.enrolmentCurrency;
    const wellnessCurrency = data.data.clientSettings.wellnessCurrency;
    const {
      benefitsEnrolment: benefitsData,
      eCommerce: wellnessData,
      paymentSummary: summary,
    } = data.panels;
    const benefits = benefitsData.benefits.items;
    const wellness = wellnessData.wellness.items;
    const itemRemovedMessages = wellnessData.wellness.messages;

    const {
      okToCheckOut: canCheckout,
      hasEcommerce: hasShop,
      checkoutNote,
      payment: paymentInfo,
      productSummaryAgreement: agreementInfo,
      purchaseBreakdown,
      allowOverpuchase: alloWOverpurchase,
    } = summary;

    const isDisplayingEnrolmentAgreement =
      canCheckout &&
      isEnrolmentEnabled &&
      agreementInfo.enable &&
      benefits &&
      !!benefits.all.length;
    const hasOverpurchase =
      purchaseBreakdown.benefitsOverPurchase.numericValue > 0 ||
      purchaseBreakdown.wellnessOverPurchase.numericValue > 0;
    const displayOverpurchaseAgreement =
      canCheckout && alloWOverpurchase.enable && hasOverpurchase && alloWOverpurchase.message;
    const overPurchaseAmount = intl.formatNumber(paymentInfo.employee.numericValue, {
      format: "money",
    });
    const overPurchaseMessage =
      alloWOverpurchase.message &&
      intl
        .formatMessage({
          id: alloWOverpurchase.message,
          defaultMessage: alloWOverpurchase.message,
        })
        .replace(OVERPURCHASE_AMOUNT_TOKEN, overPurchaseAmount);

    let checkoutDisabled = false;

    if (canCheckout) {
      if (isDisplayingEnrolmentAgreement) {
        checkoutDisabled = !this.state.agreement;
      }

      if (!checkoutDisabled && displayOverpurchaseAgreement) {
        checkoutDisabled = !this.state.overPurchaseAgreement;
      }
    } else {
      checkoutDisabled = true;
    }

    return (
      <div>
        {(benefits && benefits.all.length > 0) || (wellness && wellness.all.length > 0) ? (
          <div>
            <h2>{intl.formatMessage(messages.reviewCartDescription)}</h2>
            <BenefitCheckoutItems
              isNarrowScreen={isNarrowScreen}
              intl={intl}
              benefits={benefits}
              currency={enrolmentCurrency}
            />
            <article className="card">
              <CheckoutSummary data={summary} currency={enrolmentCurrency} common={common} />
              <section>
                {canCheckout &&
                  paymentInfo.employee.numericValue > 0 &&
                  paymentInfo.overPurchaseOptions === "PayrollDeduction" && (
                    <div className="toggle-by-admin">
                      <img
                        src="/assets/images/common/payroll-deduction.png"
                        alt="Payroll Deduction"
                      />
                      {intl.formatMessage(messages.payrollDeuctionDescription)}
                    </div>
                  )}
                {canCheckout && checkoutNote && checkoutNote.value ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({
                        id: checkoutNote.value,
                        defaultMessage: checkoutNote.value,
                      }),
                    }}
                  />
                ) : (
                  <div>
                    <strong>{intl.formatMessage(messages.notesDescription)}</strong>{" "}
                    {intl.formatMessage(messages.notesContentDescription)}
                  </div>
                )}
                {isDisplayingEnrolmentAgreement && (
                  <div>
                    <Checkbox
                      name="agreement-checkbox"
                      id="agreement-checkbox"
                      onChange={this.changeAgreement}
                      label={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: intl.formatMessage({
                              id: agreementInfo.message,
                              defaultMessage: agreementInfo.message,
                            }),
                          }}
                        />
                      }
                    />
                  </div>
                )}
                {displayOverpurchaseAgreement && (
                  <div>
                    <Checkbox
                      name="overpurchase-checkbox"
                      id="overpurchase-checkbox"
                      onChange={this.changeOverpurchaseAgreement}
                      label={<div dangerouslySetInnerHTML={{ __html: overPurchaseMessage }} />}
                    />
                  </div>
                )}
                {!canCheckout && (
                  <Notification
                    level={Notification.level.error}
                    message={intl.formatMessage(messages.exceededDescription)}
                  />
                )}
                {!canCheckout &&
                  purchaseBreakdown.benefitsOverPurchase.numericValue > 0 &&
                  purchaseBreakdown.wellnessOverPurchase.numericValue > 0 && (
                    <Notification
                      level={Notification.level.error}
                      message={intl.formatMessage(messages.reviseBothDescription)}
                    />
                  )}
                {!canCheckout && purchaseBreakdown.benefitsOverPurchase.numericValue > 0 && (
                  <Notification
                    level={Notification.level.error}
                    message={intl.formatMessage(messages.reviseEnrollmentDescription)}
                  />
                )}
                {!canCheckout && purchaseBreakdown.wellnessOverPurchase.numericValue > 0 && (
                  <Notification
                    level={Notification.level.error}
                    message={intl.formatMessage(messages.reviseWellnessDescription)}
                  />
                )}
              </section>
            </article>
            <EnableShopButtons
              doCheckout={this.createCheckoutHandler(isDisplayingEnrolmentAgreement)}
              canCheckout={canCheckout}
              checkoutDisabled={checkoutDisabled}
              isEnrolmentEnabled={isEnrolmentEnabled}
              showBenefits={this.showBenefits}
              hasShop={hasShop}
              showWellness={this.showWellness}
              saving={saving}
              errorText={errorText}
            />
          </div>
        ) : (
          <EnableShopButtons
            isCartEmpty
            doCheckout={this.createCheckoutHandler(isDisplayingEnrolmentAgreement)}
            canCheckout={false}
            checkoutDisabled={checkoutDisabled}
            isEnrolmentEnabled={isEnrolmentEnabled}
            showBenefits={this.showBenefits}
            hasShop={hasShop}
            showWellness={this.showWellness}
            saving={saving}
            errorText={errorText}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = function(store) {
  return {
    error: store.error,
    items: store.cart.cartItems,
    data: store.checkout.data,
    fetching: store.checkout.fetching,
    saving: store.checkout.saving,
    saved: store.checkout.saved,
    checkoutResult: store.checkout.checkoutResult,
    networkError: store.checkout.error,
    isAuthenticated: store.login.isAuthenticated,
    isEnrolmentEnabled: store.common.isEnrolmentEnabled,
    common: store.common,
  };
};

const mapDispatchToProps = {
  loadCheckoutItems: load,
  saveCheckout: save,
  removeExpiredItems: removeExpiredItemsFromCart,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 719,
  },
})(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CheckoutContainer)
  )
);



// WEBPACK FOOTER //
// ./components/employee/shop/checkout/CheckoutContainer.js